import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/mmcCustCodeLists`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	/** 교정업체 셀렉트 정보 조회 */
	async getMmcInstList() {
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesCal/v1/mmcInsts`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	async getMesInfoList({ searchParams, pagingInfo }) {
		const queryStr = objectToQueryString({
			schMesEqipNo: searchParams.mesEqipNo?.trim(),
			mesEqipNm: searchParams.mesEqipNm?.trim(),
			calStCd: searchParams.calStCd, //교정상태
			runStCd: searchParams.runStCd, //가동상태
			user1Id: searchParams.userId,
			user1Nm: !searchParams.userId ? searchParams.userName?.trim() : '',
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			currentPage: pagingInfo.currentPage,
			pageUnit: pagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesInfo/v1/infos${queryStr}`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	async getMesInfoOne(schMesEqipNo) {
		const queryStr = objectToQueryString({ schMesEqipNo, currentPage: 1, pageUnit: 1 });
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesInfo/v1/infos${queryStr}`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	//저장 버튼 클릭시
	saveMesInfo: async popupData => {
		let url = `${BASE_URL}/mmc/mmcm/mesInfo/v1/status/1`;
		const mesEqipNo = popupData.mesEqipNo;
		if (mesEqipNo !== undefined && mesEqipNo !== '') {
			url = `${BASE_URL}/mmc/mmcm/mesInfo/v1/status/2/mesEqipNo/${mesEqipNo}`;
		}

		try {
			const response = await client.post(url, popupData);
			return response?.data || response;
		} catch (error) {
			throw error;
		}
	},

	//저장 버튼 클릭시
	reMesInfo: async popupData => {
		const mesEqipNo = popupData.mesEqipNo;
		let url = `${BASE_URL}/mmc/mmcm/mesInfo/v1/status/3/mesEqipNo/${mesEqipNo}`;

		try {
			const response = await client.post(url, popupData);
			return response?.data || response;
		} catch (error) {
			throw error;
		}
	},
	deMesInfo: async popupData => {
		const mesEqipNo = popupData.mesEqipNo;
		let url = `${BASE_URL}/mmc/mmcm/mesInfo/v1/status/4/mesEqipNo/${mesEqipNo}`;

		try {
			const response = await client.post(url, popupData);
			return response?.data || response;
		} catch (error) {
			throw error;
		}
	},

	//가동상태 변경 저장 버튼 클릭시
	savePrbmMesInfo: async prbm => {
		const url = `${BASE_URL}/mmc/mmcm/mesInfo/v1/status/1/mesEqipNo/${prbm.mesEqipNo}`;
		try {
			const response = await client.post(url, prbm);
			return response?.data || response;
		} catch (error) {
			throw error;
		}
	},

	// 교정이력 조회
	async getHistoryList(mesEqipNo, { currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			mesEqipNo: mesEqipNo?.trim(),
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesInfo/v1/mesEqipNo/${mesEqipNo}/historys${queryStr}`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},

	// 이상이력 조회
	async getHisPrbmList(mesEqipNo, { currentPage, pageUnit }) {
		const queryStr = objectToQueryString({
			mesEqipNo: mesEqipNo?.trim(),
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesInfo/v1/mesEqipNo/${mesEqipNo}/hisPrbms${queryStr}`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
	async postCalStCdUpdate(params) {
		try {
			const response = await client.post(`${BASE_URL}/mmc/mmcm/mesInfo/v1/status/${params.status}/saveCalStCdUpdate`, params.data);
			return response.data;
		} catch (error) {
			throw error?.response?.data;
		}
	}
};
